import React from 'react';
import { Modal, ModalBody, Row, Col, Button } from 'reactstrap';

const CreatedUpdatedModal = ({
  title = 'Terms and Conditions',
  subText = 'Terms and Conditions has been created successfully.',
  okBtnHandler,
  okBtnText = 'OK',
  textDarkSide = 'Created',
  ...restProps
}) => {
  return (
    <Modal size="lg" {...restProps} centered backdrop={'static'} keyboard={false} data-testid="create-update-modal">
      <ModalBody>
        <Row>
          <Col className="vl-flex-col-center">
            <div style={styles.titleContainer}>
              <span style={styles.title}>
                {title} <span style={styles.textDarkSide}>{textDarkSide}</span>
              </span>
            </div>
            <div style={styles.subText}>{subText}</div>
            <div className="vl-flex-row-center" style={styles.btnsContainer}>
              <Button style={styles.btnMain} type="button" onClick={okBtnHandler} data-testid="modal-ok-btn">
                {okBtnText}
              </Button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export { CreatedUpdatedModal };

const styles: Record<string, React.CSSProperties> = {
  btnsContainer: { marginBottom: '30px' },
  btnMain: {
    width: '110px',
    backgroundColor: 'var(--productPrimary)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productPrimary)',
    color: 'var(--productPrimaryDark)'
  },
  btnGray: {
    width: '110px',
    backgroundColor: 'var(--productGray)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productGray)',
    marginRight: '10px'
  },
  title: { color: 'var(--productPink)', fontWeight: 'bold' },
  textDarkSide: { color: 'var(--productPrimaryDark)', fontWeight: 'bold' },
  titleContainer: { fontSize: '30px' },
  subText: {
    color: 'var(--productPrimaryDark)',
    fontSize: '14px',
    marginTop: '30px',
    marginBottom: '30px',
    textAlign: 'center'
  }
};

/* //Example
<CreatedUpdatedModal
  isOpen={modalEditDetailsCancel}
  toggle={toggleModalEditDetailsCancel}
  okBtnHandler={()=>{}}
/>
*/
